import React from 'react';
import { Label } from 'semantic-ui-react';

const ErrorLabel = ({ message }) => <Label color='red' basic pointing>{message}</Label>

export default ErrorLabel;